import { gql } from "@apollo/client";

export const GET_ACTION_CARDS = gql`
  query {
    getCurrentActions {
      orderId
      startTime
      endTime
      cmsTag
      component
      list {
        imageDesktop
        imageMobile
        title
        description
        cta
        linkTo
      }
    }
  }
`;
